import { render, staticRenderFns } from "./FooterImprint.vue?vue&type=template&id=5beb704d"
import script from "./FooterImprint.vue?vue&type=script&lang=js"
export * from "./FooterImprint.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports